module.exports = __webpack_public_path__ + "img/customer_home_alpha.8ce15e88.svg";